import { graphql } from 'src/gql';

// A member of a collapsed bulk card (UNO-588). Pulls the same display/content/link
// fragments the card uses so each modal row renders + deep-links like a normal
// alert. Extracted from inbox-card so inbox-group-dialog can reference it without
// importing back into the card (avoids a module cycle).
export const InboxGroupMemberFragment = graphql(/* GraphQL */ `
  fragment InboxGroupMember on Alert {
    id
    typeOf
    subject
    household {
      salesforceAccountId
    }
    ...GetAlertDisplayName
    ...GetAlertContent
    ...GetAlertLink
  }
`);
